import BoxedItem from './BoxedItem';

export default BoxedItem;
